import React from "react";
import { About } from "./about";
import { Conferences } from "./conferences";
import { Team } from "./team";
import { Contact } from "./contact";
import { useTranslation } from "react-i18next";
export const AboutCompany = ({landingPageData, openPopup}) => {
    const { t } = useTranslation();


  return (
    <div>
      <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2> { t("AboutCompany.aboutTitle") } </h2>
              <p>{landingPageData ? t("AboutCompany.paragraph1") : "loading..."}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
      <Conferences data={landingPageData.Conferences} />
      <Team data={landingPageData.Services} />
      <Contact openPopup={openPopup} data={landingPageData.Contact} />
    </div>
  );
};
